import { ShortcutCard } from '@iese-chatbot/common-utils';
import {
  abstractKeywordsShortcut,
  articleShortcut,
  caseShortcut,
  syllabusShortcut,
  teachingNoteShortcut,
  technicalNoteShortcut,
} from './shortcuts.data';

export const shortcutCards: ShortcutCard[] = [
  {
    title: 'Create a teaching note',
    helpMessage:
      'Develop a comprehensive guide that enables educators at other institutions to effectively teach your case study. This note will include teaching strategies, discussion points, and insights to ensure a rich learning experience.',
    eventName: 'Teaching Note',
    shortcuts: [teachingNoteShortcut],
    visible: true,
  },
  {
    title: 'Create a new academic content',
    helpMessage:
      "Create new teaching materials for your academic sessions using both IESE's copyrighted knowledge and outside information from the Internet.",
    eventName: 'Academic Content',
    shortcuts: [caseShortcut, technicalNoteShortcut, articleShortcut],
    visible: true,
  },
  {
    title: 'Create a syllabus proposal',
    helpMessage:
      'Design a detailed proposal for a new program or course. This will include learning objectives, course structure, required materials, and evaluation methods, giving a clear blueprint for academic success.',
    eventName: 'Syllabus',
    shortcuts: [syllabusShortcut],
    visible: true,
  },
  {
    title: 'Abstract creation and keyword extraction',
    helpMessage:
      'Summarize your content efficiently and identify key terms. This tool provides concise abstracts and extracts relevant keywords, making your research and documents more accessible and searchable.',
    eventName: 'Abstract',
    shortcuts: [abstractKeywordsShortcut],
    visible: true,
  },
  /*{
    title: 'Translate this content',
    helpMessage:
      'Translate your academic materials while adhering to our style guide. This ensures that your content maintains its original intent and quality across different languages, facilitating broader dissemination and understanding.',
    eventName: 'Translations',
    shortcuts: [translationsShortcut],
    visible: true,
  },*/
];
